import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bt-icon text-primary" }
const _hoisted_2 = { class: "dialog-confirm__title" }
const _hoisted_3 = { class: "dialog-confirm__message" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "dialog-confirm__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-confirm"
  }, {
    default: _withCtx(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode(_component_InlineSvgScoped, {
          src: 
                  require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
              ,
          "aria-label": "icon-alert-medium-outline"
        }, null, 8, ["src"])
      ]),
      _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1),
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.dialogMessage), 1),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-secondary text-uppercase mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button--m",
          onClick: _ctx.doConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Ok")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}